"use client";

import { c as _c } from "react/compiler-runtime";
import { SlotTableLegendProps } from "../availabilities/types";
import { SlotComponent } from "./slot-component";
export function SlotTableLegend(t0) {
  const $ = _c(7);
  const {
    children,
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex flex-row flex-wrap gap-2 max-w-full">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <div className="mt-2 flex flex-col justify-center items-center w-full gap-2 sm:justify-end">{t2}{children}</div>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(el) {
  return <div key={el.title} className="flex items-center justify-end gap-2 w-full sm:w-auto sm:flex-1"><div className={`h-6 flex-1 rounded-full bg-gray-200 flex items-center flex-shrink-0 relative min-w-[200px]
							${el.selectedCounterSlots && el.selectedSlot ? "justify-between" : el.selectedCounterSlots ? "justify-start" : el.selectedSlot ? "justify-end" : "justify-center"}`}><SlotComponent {...el} slotValue={new Date()} /></div><div className="text-xs w-24 lg:w-32 truncate sm:whitespace-nowrap">{el.title}</div></div>;
}